/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Mixins
import personPickerMixin from 'ui/mixins/meetings/person-picker';
import rsvpChangeWarningMixin from 'ui/mixins/meetings/rsvp-change-warning';

// Components
import BaseControl from 'shared/ui/components/form-components/BaseControl.vue';
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';
import CustomSelect from 'shared/ui/components/form-components/CustomSelect.vue';
import GenericDocExternalPicker from 'shared/ui/components/form-components/pickers/GenericDocExternalPicker.vue';
import ParticipantAvailability from 'ui/components/meetings/meeting-requests/ParticipantAvailability.vue';
import Badge from 'shared/ui/components/Badge.vue';

const __vue_script__ = {
    name: 'OrganizerPicker',

    components: { Badge, BaseSelect, CustomSelect, GenericDocExternalPicker, ParticipantAvailability },
    extends: BaseControl,

    mixins: [personPickerMixin, rsvpChangeWarningMixin],

    data() {
        return {
            attrs: {},
            loading: false,
            attendees_script: 'meetings/get-attendees-for-picker',
            exclusions: [],
            excludeProspects: true,
        };
    },

    methods: {
        setStatuses(statuses) {
            this.setPersonAttendance(this.innerValue, statuses?.attendance);
            this.setPersonPresence(this.value, statuses?.presence);
        },

        ensureDefaultStatuses(input) {
            this.setPersonAttendance(input);
            this.setPersonPresence(input);
        },

        handleInput() {
            this.warnUserAboutRSVPChange();
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "organizer-picker form-group" },
    [
      _c(
        "generic-doc-external-picker",
        _vm._b(
          {
            staticClass: "op_col form-groups",
            attrs: {
              "emit-key": "_id",
              "fp-type": "person",
              appscript: _vm.attendees_script,
              "appscript-extra-params": {
                excludeProspects: _vm.excludeProspects,
              },
              "value-key": "ids",
              name: _vm.name,
              "event-id": _vm.event._id,
              placeholder: _vm.placeholder,
              "emit-objects": true,
              multiple: false,
              sortable: false,
              exclusions: _vm.exclusions,
              errors: _vm.errors,
            },
            on: { input: _vm.ensureDefaultStatuses },
            model: {
              value: _vm.innerValue,
              callback: function ($$v) {
                _vm.innerValue = $$v
              },
              expression: "innerValue",
            },
          },
          "generic-doc-external-picker",
          _vm.attrs,
          false
        )
      ),
      _vm.innerValue
        ? _c(
            "div",
            { staticClass: "op_col" },
            [
              _c("div", { staticClass: "op_col-header" }, [
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("meetings.details.meeting_response"))),
                ]),
                _c("i", {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip.top",
                      value: _vm.$t("meetings.form.hints.meeting_response"),
                      expression: "$t('meetings.form.hints.meeting_response')",
                      modifiers: { top: true },
                    },
                  ],
                  staticClass: "tip ic-info-fill",
                }),
              ]),
              _c("custom-select", {
                attrs: {
                  "emit-option-value-only": true,
                  name: _vm.name + "-acceptance",
                  options: _vm.acceptanceOptions,
                  "allow-empty": false,
                  disabled: _vm.disabled,
                  custom: true,
                },
                on: { input: _vm.handleInput },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "customOption",
                      fn: function (ref) {
                        var option = ref.option
                        return [
                          _c(
                            "badge",
                            { attrs: { config: { classes: [option.value] } } },
                            [_vm._v(_vm._s(option.label))]
                          ),
                        ]
                      },
                    },
                    {
                      key: "customSingleLabel",
                      fn: function (ref) {
                        var option = ref.option
                        return [
                          _c(
                            "badge",
                            { attrs: { config: { classes: [option.value] } } },
                            [_vm._v(_vm._s(option.label))]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2312553302
                ),
                model: {
                  value: _vm.innerValue.attendance,
                  callback: function ($$v) {
                    _vm.$set(_vm.innerValue, "attendance", $$v)
                  },
                  expression: "innerValue.attendance",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.innerValue
        ? _c(
            "div",
            { staticClass: "op_col wide" },
            [
              _c("div", { staticClass: "op_col-header" }, [
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("meetings.details.set_attendance"))),
                ]),
                _c("i", {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip.top",
                      value: _vm.$t("meetings.form.hints.set_attendance"),
                      expression: "$t('meetings.form.hints.set_attendance')",
                      modifiers: { top: true },
                    },
                  ],
                  staticClass: "tip ic-info-fill",
                }),
              ]),
              _c("base-select", {
                attrs: {
                  "emit-option-value-only": true,
                  name: _vm.name + "-presence",
                  "allow-empty": false,
                  disabled: _vm.disabled,
                  label: _vm.options.acceptance_label,
                  options: _vm.presenceOptions,
                },
                model: {
                  value: _vm.innerValue.presence,
                  callback: function ($$v) {
                    _vm.$set(_vm.innerValue, "presence", $$v)
                  },
                  expression: "innerValue.presence",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/meetings/attendance/OrganizerPicker.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__